'use strict';

angular.module('directives.employees')

.controller('empMoreInfosController', ['$scope', 'employeeService', function ($scope, employeeService) {

    // Get More Infos On Employee
    employeeService
        .getMoreInfosOnEmployeeByID($scope.employee.EmployeeID)
        .then(function (moreInfos) {
            $scope.employee.EmployeeSecondaryLocations = moreInfos.EmployeeSecondaryLocations;
        });
}]);